import { Descriptions, Skeleton, Space, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import ticketService from '../../../services/ticket/ticket.service';
import numberHelper from '../../../helpers/functions/number.helper';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import { EllipsisOutlined } from '@ant-design/icons';

const GenerateConsolidateConfirmation = ({ park, ticket_ids = [], }) => {
    const [state, setState] = useState({
        loading : false,
        tickets : [],
    })

    const fetchTickets = async () => {
        setState(state => ({...state, loading : true, }));
        // const paymentStatusResponse = await otherService.getPaymentStatus();
        //set filter on only completed payment status
        // const complete_payment_status = paymentStatusResponse?.payment_statuses?.filter(x => x.is_payment_complete);
        // const complete_payment_status_ids = complete_payment_status?.map(x => x.payment_status_id);
        // const { start_date, end_date, purchase_type_ids, } = filter ?? {};
        const ticketListingResponse = await myinvoisTransService?.fetchSelectedTickets({
            park_ids : [park?.park_id],
            // ...(is_all ? ({
            //     is_all : true,
            //     payment_status_ids : complete_payment_status_ids,
            //     is_myinvois_documents : false,
            //     // payment date
            //     start_date, end_date,
            //     purchase_type_ids,
            // }) : ({ ticket_ids, })),
            ticket_ids,
            size : ticket_ids?.length,
        }).catch(err => {
            setState(state => ({...state, loading : false, }));
        });
        
        const { count, rows : tickets, } = ticketListingResponse?.tickets;
        setState(state => ({...state, loading : false, tickets,}))
    }

    useEffect(() => {
        if(ticket_ids?.length > 0) fetchTickets();
    }, [park, ticket_ids])

    return (
        <>
            <Descriptions
            size='small'
            colon={false}
            layout='vertical'
            column={2}
            bordered
            items={[{
                key : 'park',
                label : 'Park',
                children : park?.name,
                span : 2,
            },{
                key : 'transaction_count',
                label : 'Transaction Count',
                children : (
                    <>
                        <span>{state?.tickets?.length}</span>
                    </>
                ),
                span : 2,
            },{
                key : 'count',
                label : 'Transactions',
                children : (
                    <>
                        {
                            state?.loading ? (
                                <>
                                    <Space>
                                    {
                                        [...Array(4)]?.map((x, index) => <Skeleton.Input size='small' key={index} />)
                                    }
                                    </Space>
                                </>
                                
                            )
                            :
                            (
                                <>
                                    {
                                        state?.tickets?.slice(0, 50)?.map((ticket, index) => {
                                            return (
                                                <>
                                                    <Space wrap>
                                                        <Tag>{ticket?.running_number}</Tag>
                                                    </Space>
                                                </>
                                            )
                                        })
                                    }
                                    {
                                        state?.tickets?.length > 50 && (
                                            <>
                                                    <span style={{ fontSize : 12, color : 'var(--secondary-text-color)', }}>
                                                        <Space>{`${state?.tickets?.length - 50} More`}<EllipsisOutlined /></Space>
                                                    </span>
                                            </>
                                        )
                                    }
                                </>
                            )
                        }
                    </>
                ),
                span : 2,
            },{
                key : 'amount',
                label : 'Amount',
                children : (
                    <>
                        <span>{`${park?.currency?.code} ${numberHelper.commaNumber(state?.tickets?.reduce((a, b) => (a + parseFloat(b?.payment_amount)), 0))}`}</span>
                    </>
                ),
                span : 2,
            }]}
            />
        </>
    );
}

export default GenerateConsolidateConfirmation;